<div class="side-bar {{ className }}" *ngIf="isSideBar">
  <h4 class="text-center">Uploaded Files</h4>
  <hr />
  <div class="row mt-2 mb-1" style="height: 400px; overflow: auto">
    <div class="col-md-12 overflow-auto">
      <div class="row mt-2 mb-1">
        <div *ngFor="let process of processes" class="col-md-12 mb-3">
          <div class="process-card">
            <i class="fas fa-file-alt process-card-icon"></i>
            <div class="process-card-body">
              <div class="process-card-header">
                <a title="{{ process.fileName }}" class="fileName">{{
                  process.fileName
                }}</a>
                <button
                  class="btn btn-danger btn-sm cancel-button"
                  (click)="onCancelProcess(process)"
                >
                  <mat-icon>cancel</mat-icon> Cancel
                </button>
              </div>
              <div class="process-card-badges">
                <span
                  class="badge badge-info badge-pill"
                  *ngIf="
                    processType === 29 &&
                    process?.rowProcessCount != process?.totalRowCount
                  "
                  >{{ process?.rowProcessCount }}/{{
                    process?.totalRowCount
                  }}</span
                >
                <span class="badge badge-info badge-pill">{{
                  process.statusName
                }}</span>
              </div>
              <div class="process-card-progress" *ngIf="process.status !== 0">
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    aria-valuenow="50"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [style.width.%]="process.processPercent"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      class="no-data-text"
      *ngIf="
        processes === null || processes === undefined || processes.length === 0
      "
      >No data to display.</span
    >
  </div>
</div>
